import { useTranslation } from 'react-i18next';

import PromoDialog from 'components/shared/PromoDialog';

type Props = {
  onHidden?: () => void;
  onAction: () => void;
};

export default function EmbeddedDashboardPromoDialog({
  onHidden,
  onAction
}: Props) {
  const { t } = useTranslation('common');

  return (
    <PromoDialog
      title={t('embeddedDashboard.trial.title')}
      paragraphs={[
        t('embeddedDashboard.trial.paragraph1'),
        t('embeddedDashboard.trial.paragraph2'),
        t('embeddedDashboard.trial.paragraph3'),
        t('embeddedDashboard.trial.paragraph4')
      ]}
      buttonText={t('embeddedDashboard.trial.tryForFree')}
      images={[
        'assets/dashboard/overzicht.jpg',
        'assets/dashboard/urenendiensten.jpg',
        'assets/dashboard/atw.jpg',
        'assets/dashboard/verlof.jpg',
        'assets/dashboard/verstoringen.jpg'
      ]}
      onHidden={onHidden}
      onAction={onAction}
    />
  );
}
